import { injectable } from 'tsyringe';

// -----------------------------------------------------------------------------
// Usage:
// private readonly _lock = new AsyncLock();
// ...
// public async doSomething... {
//   try {
//     await this._lock.lock();
//     await this.doCriticalSection();
//   } catch {
//   } finally {
//     this._lock.unlock();
//   }
// }
@injectable()
export class AsyncLock {
  private promiseLock: Promise<void>;
  private promiseResolver: (value: void | PromiseLike<void>) => void = null;

  // ---------------------------------------------------------------------------
  public async lock(): Promise<void> {
    await this.promiseLock;

    this.promiseLock = new Promise((resolve) => {
      this.promiseResolver = resolve;
    });
  }

  // ---------------------------------------------------------------------------
  public async unlock(): Promise<void> {
    if (!this.promiseResolver) {
      return;
    }

    this.promiseResolver();
    this.promiseResolver = null;
  }
}
